import { IAddTrain, TrainSearchParams } from "@types";
import { BASE_URL, client, getErrorMessage, SSE_URL } from "./client";
import { parentModelItem } from "../recoil";

const baseUrl = "/trains";

export const getTrains = async (params?: TrainSearchParams) => {
  try {
    const response = await client.get(`${baseUrl}`, {
      params,
    });
    return response.data;
  } catch (error: any) {
    throw new Error(getErrorMessage(error));
  }
};

export const getTrainsPagination = async (params: any) => {
  try {
    const response = await client.get(`${baseUrl}`, {
      params,
    });
    return response.data;
  } catch (error: any) {
    throw new Error(getErrorMessage(error));
  }
};

export const getTrain = async (id: number) => {
  try {
    const response = await client.get(`${baseUrl}/${id}`);
    // console.log("respones", response);
    return response.data.data;
  } catch (error: any) {
    throw new Error(getErrorMessage(error));
  }
};

export const createTrain = async (trainData: IAddTrain) => {
  try {
    const response = await client.post(`${baseUrl}`, trainData);
    return response.data;
  } catch (error: any) {
    throw new Error(getErrorMessage(error));
  }
};

export const addTrain = async (trainData: IAddTrain) => {
  try {
    const response = await client.post(`${baseUrl}/add-train`, trainData);
    return response.data;
  } catch (error: any) {
    throw new Error(getErrorMessage(error));
  }
};

export const editTrain = async (id: number, trainData: IAddTrain) => {
  try {
    const response = await client.patch(`${baseUrl}/${id}`, trainData);
    return response.data;
  } catch (error: any) {
    throw new Error(getErrorMessage(error));
  }
};

export const deleteTrain = async (id: number) => {
  try {
    const response = await client.delete(`${baseUrl}/${id}`);
    return response.data;
  } catch (error: any) {
    throw new Error(getErrorMessage(error));
  }
};

// 서버의 학습상태 조회
export const getTrainStatus = async (server: string) => {
  try {
    const response = await client.get(`${baseUrl}/status?server=${server}`);
    return response.data;
  } catch (error: any) {
    throw new Error(getErrorMessage(error));
  }
};

export const getTrainStop = async (server: string) => {
  try {
    const response = await client.get(`${baseUrl}/stop?server=${server}`);
    return response.data;
  } catch (error: any) {
    throw new Error(getErrorMessage(error));
  }
};

// 학습 진행상황 조회
export const getTrainStatusSSE = (mgmtServer: string) => {
  try {
    const eventSource = new EventSource(`${BASE_URL}/statusSSE?server=${mgmtServer}`, { withCredentials: true });

    eventSource.onmessage = (event) => {
      const data = JSON.parse(event.data);
      console.log("data", data);
    };
    eventSource.onerror = (error) => {
      console.error("SSE Error:", error);
    };
    return eventSource;
  } catch (error: any) {
    throw new Error(getErrorMessage(error));
  }
};

export const getAILabelSSE = (id: number, create_at: string) => {
  try {
    const eventSource = new EventSource(`${BASE_URL}/insp-ai-label/${id}`, {
      withCredentials: true,
    });
    eventSource.onmessage = (event) => {
      const data = JSON.parse(event.data);
      console.log("data", data);
    };
    eventSource.onerror = (error) => {
      console.error("SSE Error:", error);
    };
    return eventSource;
  } catch (error: any) {
    throw new Error(getErrorMessage(error));
  }
};

export const stopTrain = async (trainLog_uuid: string) => {
  try {
    const response = await client.patch(`${baseUrl}/stop-train/${trainLog_uuid}`);
    return response.data;
  } catch (error: any) {
    throw new Error(getErrorMessage(error));
  }
};

export const getTrainDetail = async (uuid: string) => {
  try {
    const response = await client.get(`${baseUrl}/detail/${uuid}`);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const editTrainCondition = async (id: number, trainData: any) => {
  try {
    const response = await client.patch(`${baseUrl}/edit-condition/${id}`, trainData);
    return response.data;
  } catch (error: any) {
    throw new Error(getErrorMessage(error));
  }
};

export const startTrain = async (uuid: string, ai_server: string) => {
  try {
    const response = await client.patch(`${baseUrl}/start-train/${uuid}`, {
      ai_server: ai_server || "",
    });
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

type epochTrainParams = {
  uuid: string;
  img_count: number;
  dataset_path: string;
  model_id: number;
  ip: string;
  epoch: number;
  img_per_epoch: number;
  auto_valid: boolean;
  saveOption: any;
  parentModel: parentModelItem | null; //이어학습 진행 시
  overkillCondition: number;
};
export const startEpochTrain = async (params: epochTrainParams) => {
  try {
    const response = await client.post(`/ai/epoch-train`, {
      ...params,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// 일반 학습(ImageTable) 정지
export const stopProjectTrain = async (params: { uuid: string; ip: string }) => {
  const response = await client.post(`/ai/stop-train`, params);
  return response.data;
};

export const stopEpochTrain = async (params: { uuid: string; ip: string }) => {
  try {
    const response = await client.post(`/ai/stop-epoch-train`, {
      ...params,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
